var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 120,
    viewBox: "0 0 201 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5625 48.8125C93.7969 48.8125 95.6875 50.7031 95.6875 52.9375C95.6875 55.2578 93.7969 57.0625 91.5625 57.0625C89.2422 57.0625 87.4375 55.2578 87.4375 52.9375C87.4375 50.7031 89.2422 48.8125 91.5625 48.8125ZM116.914 41.25C120.008 41.25 122.414 43.7422 122.414 46.75V74.25C122.414 77.3438 119.922 79.75 116.914 79.75H83.9141C80.9062 79.75 78.4141 77.3438 78.4141 74.25V46.75C78.4141 43.7422 80.9062 41.25 83.9141 41.25H116.914ZM118.289 73.7344V46.75C118.289 46.0625 117.688 45.375 116.914 45.375H83.9141C83.2266 45.375 82.5391 46.0625 82.5391 46.75L82.625 74.25L89.0703 66.1719C89.4141 65.8281 89.8438 65.5703 90.3594 65.5703C90.875 65.5703 91.3047 65.8281 91.6484 66.1719L94.8281 70.125L103.938 57.75C104.281 57.3203 104.711 57.0625 105.312 57.0625C105.828 57.0625 106.258 57.3203 106.516 57.75L118.289 73.7344Z",
    fill: "#C5CAD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.80eec390c3aeded99acb5602d9af8c06.svg";
export { ForwardRef as ReactComponent };